import React, { useState, useEffect } from 'react';
import logo from './assets/FLOW_logo_black.png';
import './App.css';
import { BrowserRouter as Router, Routes, Route, NavLink, Navigate, useNavigate } from "react-router-dom";
import Customization from './components/Customization/Customization';
import Comments from './components/Comments/Comments';
import Partners from './components/Customization/Partners';
import Infos from './components/Customization/Infos';
import DataVisualisation from './components/DataVisualisation/DataVisualisation';
import Organizations from './components/Organizations/Organizations';
import Statistics from './components/Statistics/Statistics';
import Excursion from './components/Excursions/Excursion';
import ManageOrganizations from './components/OrganizationsDetails/Organization';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import Login from './components/Loging/Login';
import { login, logout, isProtected } from './controllers/PasswordsController';
import MainMenu from './components/MainMenu/MainMenu';
import { Tabs, Tab, Box } from '@mui/material';


function App() {
  const [user, setUser] = useState(null);
  return (
    <Router>
      <AppContent setUser={setUser} />
    </Router>
  );
}

function AppContent({ setUser }) {
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(0);
  const [user, setUserState] = useState(null);
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const protectedStatus = await isProtected();
        if (protectedStatus && !user) {
          navigate('/login');
        }
        setIsAuthChecked(true);
      } catch (error) {
        console.error('Error checking auth status:', error);
        setIsAuthChecked(true);
      }
    };
    checkAuth();
  }, [user, navigate]);

  const handleLogout = async () => {
    try {
      await logout();
      setUserState(null);
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const resetCurrentTab = () => {
    setCurrentTab(null);
  };

  if (!isAuthChecked) {
    return <div>Loading...</div>;
  }

  return (
    <div className="App">
      <header>
        <img src={logo} className="App-logo" alt="logo" />
        {user && user.isAuthenticated &&
          <nav >
            <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
              <Tabs
                value={currentTab}
                onChange={(event, newValue) => setCurrentTab(newValue)}
                role="navigation"
              >
                
                <Tab tabIndex={0} label="Prélèvements" component={NavLink} to="/data" />
                <Tab tabIndex={1} label="Statistiques" component={NavLink} to="/statistics" />
                <Tab tabIndex={2} label="Expéditions" component={NavLink} to="/excursions" />
              </Tabs>
              <MainMenu handleLogout={handleLogout} selectOption={resetCurrentTab} />
            </Box>
          </nav>
        }
      </header>

      <main>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/excursions" element={<ProtectedRoute user={user}><Excursion/></ProtectedRoute>} />
          <Route path="/comments" element={<ProtectedRoute user={user}><Comments /></ProtectedRoute>} />
          <Route path="/organizations" element={<ProtectedRoute user={user}><Organizations /></ProtectedRoute>} />
          <Route path="/organizations/:id" element={<ProtectedRoute user={user}><ManageOrganizations /></ProtectedRoute>} />
          <Route path="/data" element={<ProtectedRoute user={user}><DataVisualisation /></ProtectedRoute>} />
          <Route path="/statistics" element={<ProtectedRoute user={user}><Statistics /></ProtectedRoute>} />
          <Route path="/customization" element={<ProtectedRoute user={user}><Customization /></ProtectedRoute>} />
          <Route path="/partners" element={<ProtectedRoute user={user}><Partners /></ProtectedRoute>} />
          <Route path="/infos" element={<ProtectedRoute user={user}><Infos /></ProtectedRoute>} />
          <Route path="/login" element={<Login setUser={setUserState}/>} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </main>
    </div >
  );
}

export default App;
